import {keyframes} from '@emotion/react';
import styled from '@emotion/styled';

import {mixinSVGIcon, mixinSVGIconSmall} from '@ELib/styles/mixins';

const flyIn = keyframes`
  0%   { 
    transform: translateX(200%); 		
  }
  100% { 
    transform: translateX(0%); 
  }
`;

export const StyledStatusIcon = styled.span`
  margin: 0 var(--gutter-little);
  color: var(--color-core-white);
  height: var(--icon-dimension);

  svg {
    ${mixinSVGIcon}
  }
`;

export const StyledSnackbar = styled.div`
  position: relative;
  font-size: var(--font-size-tiny);
  font-weight: var(--snackbar-font-weight);
  height: var(--snackbar-height);
  color: var(--color-core-white);
  display: flex;
  align-items: center;
  z-index: var(--zindex-snackbar);
  transition: bottom 0.4s cubic-bezier(0, 0, 0.2, 1);
  border-radius: var(--snackbar-border-radius);
  animation: ${flyIn} 1s;

  pointer-events: auto;

  background-color: purple;

  &.info {
    background-color: var(--color-alerts-info);
  }

  &.success {
    background-color: var(--color-alerts-success);
  }

  &.warning {
    background-color: var(--color-alerts-error);
  }

  &.delete {
    background-color: var(--color-core-black);
    padding-left: var(--gutter);
  }

  .close-button {
    margin: 0 var(--gutter);
    padding: var(--gutter-tiny);

    svg {
      ${mixinSVGIconSmall}
      fill: var(--color-core-grey-light);
    }
  }
`;

export const SnackbarCounter = styled.span`
  position: absolute;
  top: -10px;
  left: -10px;

  display: flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: var(--color-core-primary);
  font-weight: var(--font-weight-highlight);
`;
